import type { ComponentType } from 'react';
import type { EntityAdminWorkflowMetadata } from './types';

/**
 * Attaches workflow metadata to a component, producing an EntityAdminWorkflowComponent.
 * Use this instead of manually calling Object.assign.
 */
export function createWorkflowComponent<T extends ComponentType>(
  component: T,
  workflow: EntityAdminWorkflowMetadata
): T & { workflow: EntityAdminWorkflowMetadata } {
  return Object.assign(component, { workflow });
}
